import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id");
    if (!sid) { setStatus("done"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch {}
      if (++tries < 6) setTimeout(poll, 2000); else setStatus("done");
    };
    poll();
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="panel rounded-sm p-10 text-center max-w-md rise">
        <CheckCircle2 size={48} className="mx-auto mb-4" style={{ color: "#34D399" }} />
        <h1 className="font-serif text-3xl mb-2">{status === "paid" ? "Payment Received" : "Processing Payment"}</h1>
        <p className="text-sm text-[#8C867A] mb-6">{status === "paid" ? "Your membership payment has been recorded. Thank you." : "We're confirming your payment. This may take a moment."}</p>
        <button onClick={() => navigate("/membership")} className="btn-brass px-6 py-3 rounded-sm text-sm">Back to Membership</button>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="panel rounded-sm p-10 text-center max-w-md rise">
        <XCircle size={48} className="mx-auto mb-4" style={{ color: "#F59E0B" }} />
        <h1 className="font-serif text-3xl mb-2">Payment Cancelled</h1>
        <p className="text-sm text-[#8C867A] mb-6">No charge was made. You can complete your membership payment anytime.</p>
        <button onClick={() => navigate("/membership")} className="btn-brass px-6 py-3 rounded-sm text-sm">Back to Membership</button>
      </div>
    </div>
  );
}
